// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"766485f5","453":"714a1d45","455":"9838039a","762":"8b16afe6"}[chunkId] + ".chunk.js";
};